
































import Vue from 'vue';
import {
  LeadStatistic,
  PaginationData,
  ResponseExport,
  typeTraffic,
  userRoles,
} from '@/types';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import Table from '@/components/table/Table.vue';
import {
  Column,
  ColumnItems,
  FilterTypeField,
  Row,
} from '@/components/table/types';
// @ts-ignore
import { saveAs } from 'file-saver';
import FieldDatePicker from '@/components/form/FieldDatePicker.vue';
import filterParams from '@/components/table/utils/filterParameters';
import { mapGetters } from 'vuex';

export default Vue.extend({
  name: 'LeadStatistics',
  async mounted() {
    const params = filterParams.getUrlFilter(this.$route.query['filter']) || {};
    this.$store.commit('changeTitle', this.$t('pages.statisticsLead.title'));
    if (params['from_date'] && params['to_date']) {
      this.datePeriod = [params['from_date'], params['to_date']];
    }
    this.getLeadStatistics(params);
    await this.$store.dispatch('countries');
    const country = this.columns.find((item: Column): boolean => {
      return item.field === 'geo';
    });
    if (country) {
      country.items = this.$store.getters.countriesList;
    }

    if (this.userCan(this.roles.ADMIN)) {
      await this.$store.dispatch('users');
      const users = this.columns.find((item: Column): boolean => {
        return item.field === 'user_id';
      });

      if (users) {
        users.items = this.userList;
      }
    }
  },
  components: {
    Table,
    FieldDatePicker,
  },
  computed: {
    statistics(): Array<any> {
      return this.$store.state.statistics.lead.data.map(
        (item: LeadStatistic) => {
          return {
            created_at: item.created_at,
            offer: item.offer,
            country_code: item.country_code,
            ssp_id: item.ssp_id,
            site_id: item.site_id,
            ssp_name: item.ssp_name,
            site_domain: item.site_domain,
            campaign_id: item.campaign_id,
            campaign_name: item.campaign_name,
            creative_id: item.creative_id,
            type_traffic: item.type_traffic,
            status: item.status,
            device_type: item.device_type,
            cr: item.cr,
            cpa: item.cpa,
            order_cost: item.order_cost,
          };
        }
      );
    },
    total(): Row {
      return this.$store.state.statistics.lead.total;
    },
    paginationData(): PaginationData {
      return this.$store.state.statistics.lead.paginationData;
    },
    ...mapGetters({
      userCan: 'userCan',
      userList: 'userList',
    }),
  },
  methods: {
    defaultPeriod() {
      const from = new Date();
      const to = new Date();
      this.datePeriod = [
        ('0' + to.getDate()).slice(-2) +
          '.' +
          ('0' + (to.getMonth() + 1)).slice(-2) +
          '.' +
          to.getFullYear(),
        ('0' + from.getDate()).slice(-2) +
          '.' +
          ('0' + (from.getMonth() + 1)).slice(-2) +
          '.' +
          from.getFullYear(),
      ];
    },
    changeDatePeriod() {
      this.getLeadStatistics(this.searchData);
    },
    async getLeadStatistics(searchData) {
      let columns: Array<string> = [];
      this.loadData = true;
      this.searchData = searchData;
      this.columns.map((item: Column, index) => {
        if (searchData[item.field]) {
          this.columns[index].filterValue = searchData[item.field];
        } else {
          this.columns[index].filterValue = null;
        }
      });
      if (
        !this.datePeriod.length ||
        this.datePeriod.find((i) => i === null) === null
      ) {
        this.defaultPeriod();
      }

      if (Array.isArray(this.datePeriod) && this.datePeriod.length == 2) {
        this.searchData['from_date'] = this.datePeriod[0];
        this.searchData['to_date'] = this.datePeriod[1];
      }
      if (this.searchData['sort']) {
        this.sort = this.searchData['sort'];
      }

      columns = this.columns
        .filter((col) => {
          return !!col.visible || col.visible == undefined;
        })
        .map((col) => col.field);

      await this.$store.dispatch('leadStatistics', {
        searchData: this.searchData,
        columns,
      });
      filterParams.toUrl({
        ...this.searchData,
      });
      filterParams.saveFilter();
      this.loadData = false;
    },
    exportData() {
      this.$confirm({
        title: this.$t('body.popup.export.title'),
        content: this.$t('body.popup.export.message'),
        cancelText: this.$t('body.popup.buttons.no'),
        okText: this.$t('body.popup.buttons.yes'),
      })
        .then(() => {
          this.exportDataConfirmed();
        })
        .catch(() => {});
    },
    async exportDataConfirmed() {
      const response: ResponseExport = await this.$store.dispatch(
        'exportLeadStatistics',
        this.searchData
      );
      saveAs(response.download_link, 'export.xls');
    },
  },
  data() {
    return {
      searchData: {},
      datePeriod: [] as Array<string>,
      columns: [
        {
          name: this.$t('pages.statisticsLead.table.header.data'),
          field: 'created_at',
          filterValue: null,
          isSticky: true,
          options: {
            left: '0',
          },
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.offer'),
          field: 'offer',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.geo'),
          field: 'country_code',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.sspId'),
          field: 'ssp_id',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.sspName'),
          field: 'ssp_name',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.siteId'),
          field: 'site_id',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.siteDomain'),
          field: 'site_domain',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.idCampaign'),
          field: 'campaign_id',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.nameCampaign'),
          field: 'campaign_name',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.idCreative'),
          field: 'creative_id',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.trafficType'),
          field: 'type_traffic',
          items: [
            {
              label: this.$t('body.table.body.trafficType.banner'),
              value: typeTraffic.BANNER,
            },
            {
              label: this.$t('body.table.body.trafficType.push'),
              value: typeTraffic.PUSH,
            },
            {
              label: this.$t('body.table.body.trafficType.native'),
              value: typeTraffic.NATIVE,
            },
          ] as Array<ColumnItems>,
          filterValue: null,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.deviceType'),
          field: 'device_type',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsLead.table.header.statusLead'),
          field: 'status',
          filterValue: null,
          useInFilter: false,
        },
        {
          name: this.$t('pages.statisticsCampaign.topBar.selectUser'),
          field: 'user_id',
          items: [],
          visible: false,
          filterTypeField: FilterTypeField.FILTER_TYPE_DROPDOWN_FIELD,
          filterValue: null,
          role: userRoles.ADMIN,
        },
      ] as Array<Column>,
      loadData: true,
      gridOptions: {
        pagination: true,
      },
      sort: null as string | null,
      selectedUser: null,
      roles: {
        ADMIN: userRoles.ADMIN,
        MANAGER: userRoles.MANAGER,
        SSP: userRoles.SSP,
        PUBLISHER: userRoles.PUBLISHER,
      },
    };
  },
});
